var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState, useCallback } from "react";
import { useNavigateKeepSession } from "../../tools/useNavigateKeepSession";
import { ETeam, ETurn, ETypeCards, ECardStateGame, ECardHandler, ESlotType, deepCopy, getDefaultGameStateDTO, } from "cresus-common";
// Contexts & Tools
import { useBoardGame, } from "../../contexts/BoardGameProvider";
import useSessionContext from "../../tools/useSessionContext";
import useMedia from "../../contexts/useMedia";
// Components
import ChargesNotebookComponent from "../../components/player_game_element_component/ChargesNotebookComponent";
import MoneyAndPleasureInfoComponent from "../../components/player_game_element_component/MoneyAndPleausreInfoComponent";
import MyTeamDisplayComponent from "../../components/player_game_element_component/MyTeamDisplayComponent";
import SetOfButtonsPlayerComponent from "../../components/player_game_element_component/SetOfButtonsPlayerComponent";
import ChatComponent from "../../components/ChatComponent";
import ThrowDiceComponent from "../../components/player_game_element_component/ThrowDiceComponent";
import ShowCardComponent from "../../components/player_game_element_component/ShowCardComponent";
import ShowCardCorrectionComponent from "../../components/player_game_element_component/ShownCardCorrection";
import { CameraMode } from "../../components/3D/CameraMode";
import TeamTurnComponement from "../../components/player_game_element_component/TeamTurnComponent";
import TeamsIngameComponent from "../../components/TeamsIngameComponent";
import WaitingDrawCardComponent from "../../components/animator_components/game_components/WaitingDrawCardComponent";
import PedagogicContentPlayer from "../../components/player_game_element_component/PedagogicContentPlayer";
import RecapEndOfSessionPlayerPage from "./RecapEndOfSessionPlayerPage";
import FinalPage from "../FinalPage";
const DEFAULT_PLAYER = {
    avatarComposition: {
        bonus: 0,
        eyes: 0,
        hair: 0,
        hair_color: 0,
        mouth: 0,
        nose: 0,
        skin: 0,
        teamColor: ETeam.NONE,
    },
    name: "",
    capitain: false,
    team: ETeam.NONE,
    micOn: false,
    sessionPeerId: "undefined",
    isConnected: true,
};
function GameInProgressPage() {
    var _a, _b, _c, _d;
    const navigate = useNavigateKeepSession();
    const { moveCamera, movePawn, showDiceRoll, activatePawn, updateCameraTarget, playSound, muteSound, } = useBoardGame();
    const { sendRequest, websocketPeer, gameState } = useSessionContext();
    const { setCameraMode, audioVideoClient } = useMedia();
    // State
    const [isChatShown, setIsChatShown] = useState(false);
    const [isNotebookShown, setIsNotebookShown] = useState(false);
    const [myPlayer, setMyPlayer] = useState(deepCopy(DEFAULT_PLAYER));
    const [insideGameState, setInsideGameState] = useState(deepCopy(getDefaultGameStateDTO()));
    const [isThrowDiceActive, setIsThrowDiceActive] = useState(false);
    const [isCardBeingDrawn, setIsCardBeingDrawn] = useState(false);
    const [isPedagogicShown, setIsPedagogicShown] = useState(false);
    const [newMessageAlert, setNewMessageAlert] = useState(false);
    // // --- Helpers ---
    // const syncGameState = useCallback(
    //   (gameState: GameStateDTO, animate = true) => {
    //     if (!gameState) return;
    //     if (!gameState.teams) return;
    //     setInsideGameState(gameState);
    //     gameState.teams.forEach((team) => {
    //       movePawn(team.teamColor, team.slotTeam.slotAbsoluteNumber, animate);
    //     });
    //   },
    //   [movePawn]
    // );
    // Inside GameInProgressPage component
    const syncGameState = useCallback((gameState, animate = true) => {
        if (!gameState || !gameState.teams)
            return;
        if (!gameState.teams)
            return;
        setInsideGameState(gameState);
        gameState.teams.forEach((gameState) => {
            // 1. Ensure the pawn is active in the 3D scene
            activatePawn(gameState.teamColor);
            // 2. Move it to the correct slot
            movePawn(gameState.teamColor, gameState.slotTeam.slotAbsoluteNumber, animate);
        });
    }, [movePawn, activatePawn]); // Added activatePawn to dependencies
    // --- Memos ---
    const myTeam = useMemo(() => {
        var _a;
        return (_a = insideGameState === null || insideGameState === void 0 ? void 0 : insideGameState.teams) === null || _a === void 0 ? void 0 : _a.find((t) => t.players.some((p) => p.name === myPlayer.name));
    }, [insideGameState === null || insideGameState === void 0 ? void 0 : insideGameState.teams, myPlayer.name]);
    const teamToPlay = useMemo(() => {
        var _a;
        return (_a = insideGameState === null || insideGameState === void 0 ? void 0 : insideGameState.teams) === null || _a === void 0 ? void 0 : _a.find((t) => t.turnState !== ETurn.NO_ACTION_REQUIRED);
    }, [insideGameState === null || insideGameState === void 0 ? void 0 : insideGameState.teams]);
    const currentTeamColor = useMemo(() => { var _a; return (_a = teamToPlay === null || teamToPlay === void 0 ? void 0 : teamToPlay.teamColor) !== null && _a !== void 0 ? _a : ETeam.RED; }, [teamToPlay]);
    const cardDisplay = useMemo(() => {
        if (!(teamToPlay === null || teamToPlay === void 0 ? void 0 : teamToPlay.cardSelected))
            return { showText: false, showCorr: false };
        const { turnState, cardState, cardHandlerEnum, cardSelected } = teamToPlay;
        const isQuestion = cardSelected.type === ETypeCards.QUESTION;
        return {
            showText: (turnState === ETurn.HANDLE_DICE_RESULT &&
                cardState === ECardStateGame.CARDS_CHOSEN &&
                isQuestion) ||
                (turnState === ETurn.HANDLE_NEXT_TURN &&
                    cardState === ECardStateGame.CARDS_CHOSEN &&
                    !isQuestion),
            showCorr: turnState === ETurn.HANDLE_NEXT_TURN &&
                cardState === ECardStateGame.CARDS_CHOSEN &&
                isQuestion,
        };
    }, [teamToPlay]);
    // --- Handlers ---
    const handleToggleChat = () => {
        setIsChatShown((prev) => !prev);
        if (!isChatShown)
            setNewMessageAlert(false);
    };
    const handleThrowDice = () => __awaiter(this, void 0, void 0, function* () {
        if (!myTeam)
            return;
        setIsThrowDiceActive(false);
        try {
            const res = yield sendRequest("requestRollDice", {
                team: myTeam.teamColor,
                diceCount: 2,
            });
            const config = {
                currentTeam: myTeam.teamColor,
                closeOnRolled: true,
                diceEvent: new Map([
                    [
                        myTeam.teamColor,
                        {
                            dices: res.diceResults,
                            ShouldDiceBeRolled: true,
                            AreDicesRolled: false,
                        },
                    ],
                ]),
                isInteractable: false,
            };
            showDiceRoll(config, () => {
                console.log("CALLBACK RECEIVED IN PARENT FOR TEAM:"); // <--- Add this log
                sendRequest("makeTeamThrowDiceTurn", {
                    team: myTeam.teamColor,
                    diceResults: res.diceResults,
                });
            });
        }
        catch (e) {
            console.error(e);
        }
    });
    // --- Effects ---
    useEffect(() => {
        setCameraMode(true, false, false);
        muteSound("GlobalAmbiance");
        updateCameraTarget(ETeam.RED);
        moveCamera(CameraMode.ALL_MAP);
    }, []);
    // WebSocket Listener
    useEffect(() => {
        if (!websocketPeer)
            return;
        const refreshMethods = [
            "applicationOfEffects",
            "nextTurn",
            "makeTeamThrowDiceTurn",
            "endGame",
            "payChargeByAnimator",
            "correctQuestionCard",
            "pickNewCards",
            "chooseCard",
            "deleteCharge",
            "makeOneTeamThrowDicesEvent",
            "makeNewEventThrow",
            "payChargeByPlayer",
            "deleteCard",
            "updateGameState",
            "makeTeamsThrowDicesEvent",
        ];
        websocketPeer.on("notification", (notif) => {
            if (notif.method === "playSound")
                playSound(notif.data.sound);
            if (refreshMethods.includes(notif.method))
                syncGameState(notif.data);
            if (notif.method === "endSession") {
                setCameraMode(false, false, false);
                audioVideoClient.muteMic();
                if (notif.data)
                    setInsideGameState(notif.data);
            }
        });
    }, [
        websocketPeer,
        syncGameState,
        playSound,
        setCameraMode,
        audioVideoClient,
    ]);
    // Auto-Rejoin & Initialization
    useEffect(() => {
        if (!websocketPeer)
            return;
        let isSubscribed = true;
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                const freshState = yield sendRequest("onConnectionOrReaload", {
                    gameState,
                });
                if (!isSubscribed)
                    return;
                syncGameState(freshState !== null && freshState !== void 0 ? freshState : gameState, false);
                const savedName = sessionStorage.getItem("playerName");
                if (savedName) {
                    const joinRes = yield sendRequest("joinAsPlayer", {
                        player: Object.assign(Object.assign({}, DEFAULT_PLAYER), { name: savedName }),
                    });
                    if (joinRes) {
                        syncGameState(joinRes, false);
                        const me = yield sendRequest("getMyPlayer", { gameState: joinRes });
                        setMyPlayer(me);
                    }
                    else {
                        navigate("/ReconnectionPage");
                    }
                }
                else {
                    navigate("/ReconnectionPage");
                }
            }
            catch (e) {
                console.log("yololo", e);
                navigate("/ReconnectionPage");
            }
        }))();
        return () => {
            isSubscribed = false;
        };
    }, [websocketPeer, sendRequest, syncGameState, navigate]);
    // Turn logic: Dice & Cards
    useEffect(() => {
        setIsThrowDiceActive((myTeam === null || myTeam === void 0 ? void 0 : myTeam.turnState) === ETurn.MUST_ROLL_DICE);
        const needsCardDraw = (myTeam === null || myTeam === void 0 ? void 0 : myTeam.turnState) === ETurn.HANDLE_DICE_RESULT &&
            myTeam.cardHandlerEnum === ECardHandler.MUST_CHOOSE_CARD &&
            [ESlotType.QUESTION, ESlotType.PLAISIR, ESlotType.DILEMME].includes(myTeam.slotTeam.slotType);
        if (needsCardDraw) {
            const timer = setTimeout(() => setIsCardBeingDrawn(true), 3000);
            return () => clearTimeout(timer);
        }
        else {
            setIsCardBeingDrawn(false);
        }
    }, [myTeam]);
    // Inside GameInProgressPage component
    useEffect(() => {
        // If there is a global event active (e.g., everyone rolls for a specific event)
        if (insideGameState.isThereThrownEvent && myTeam) {
            const diceRollConfig = {
                currentTeam: myTeam.teamColor,
                closeOnRolled: false,
                diceEvent: new Map(),
                isInteractable: false, //myPlayer.capitain, // Only captains can click the dice
            };
            // Populate the map with all teams that are required to roll for this event
            insideGameState.teams
                .filter((t) => t.dicesEvent.ShouldDiceBeRolled)
                .forEach((team) => {
                diceRollConfig.diceEvent.set(team.teamColor, team.dicesEvent);
            });
            console.log("makeOneTeamThrowDicesEvent");
            showDiceRoll(diceRollConfig, (team) => __awaiter(this, void 0, void 0, function* () {
                // Callback when the captain clicks to roll
                yield sendRequest("makeOneTeamThrowDicesEvent", { teamToThrow: team });
            }));
        }
        // Cleanup: If the event is over OR we aren't rolling for turn, hide the dice UI
        if (!insideGameState.isThereThrownEvent &&
            (myTeam === null || myTeam === void 0 ? void 0 : myTeam.turnState) !== ETurn.MUST_ROLL_DICE) {
            showDiceRoll(undefined, () => __awaiter(this, void 0, void 0, function* () { }));
        }
    }, [
        insideGameState.isThereThrownEvent,
        insideGameState.teams,
        myTeam,
        myPlayer.capitain,
        showDiceRoll,
        sendRequest,
    ]);
    // --- Render ---
    if (insideGameState.gameEnded && insideGameState.sessionClosed)
        return _jsx(FinalPage, {});
    return (_jsx("div", Object.assign({ className: "flex flex-col justify-center items-center h-screen w-screen px-10", style: { paddingTop: insideGameState.sessionClosed ? "0" : "50px" } }, { children: insideGameState.gameEnded ? (_jsx(RecapEndOfSessionPlayerPage, { gameState: insideGameState })) : (_jsxs(_Fragment, { children: [_jsx(TeamsIngameComponent, { teamsInGame: insideGameState.teams, myTeam: (_a = myTeam === null || myTeam === void 0 ? void 0 : myTeam.teamColor) !== null && _a !== void 0 ? _a : ETeam.NONE }), _jsx(TeamTurnComponement, { capitain: (_b = teamToPlay === null || teamToPlay === void 0 ? void 0 : teamToPlay.players.find((p) => p.capitain)) === null || _b === void 0 ? void 0 : _b.name, teamColor: currentTeamColor }), _jsx(PedagogicContentPlayer, { setIsActive: setIsPedagogicShown }), _jsx(ChatComponent, { myPlayer: myPlayer, isChatShown: isChatShown, toggleChat: handleToggleChat, newMessageAlert: setNewMessageAlert }), !insideGameState.sessionClosed && (_jsx(SetOfButtonsPlayerComponent, { alertNewMessage: newMessageAlert, onToggleView: moveCamera, toggleChat: handleToggleChat, isMapModifiable: true, isOnlyConfigButton: false })), myTeam && myPlayer && (_jsxs(_Fragment, { children: [_jsx(ChargesNotebookComponent, { isDoubleOn: myTeam.dicesTurn.shouldReRollDices, isCaptain: myPlayer.capitain, cards: myTeam.cards, savings: myTeam.savings, numberOfMonthPlayed: Math.floor(myTeam.slotTeam.slotAbsoluteNumber / 38), turnState: myTeam.turnState, team: myTeam.teamColor, setInsideGameState: setInsideGameState, incomes: myTeam.incomes, charges: myTeam.charges, project: myTeam.project, isProjectDistributed: true, handleCLick: () => {
                                setCameraMode(true, isNotebookShown, isChatShown);
                                setIsNotebookShown(!isNotebookShown);
                            } }), _jsx(MoneyAndPleasureInfoComponent, { money: myTeam.money, pleasurePoints: myTeam.pleasurePoints })] })), isThrowDiceActive && myPlayer && (_jsx(ThrowDiceComponent, { isCaptain: myPlayer.capitain, onClickThrowDices: handleThrowDice })), isCardBeingDrawn && !cardDisplay.showText && (_jsx(WaitingDrawCardComponent, { slotType: myTeam === null || myTeam === void 0 ? void 0 : myTeam.slotTeam.slotType })), cardDisplay.showText && (_jsx(ShowCardComponent, { isThereThrowEvent: insideGameState.isThereThrownEvent, card: teamToPlay === null || teamToPlay === void 0 ? void 0 : teamToPlay.cardSelected, isActive: true })), cardDisplay.showCorr && (_jsx(ShowCardCorrectionComponent, { card: teamToPlay === null || teamToPlay === void 0 ? void 0 : teamToPlay.cardSelected, isActive: true })), myPlayer && !insideGameState.sessionClosed && (_jsx(MyTeamDisplayComponent, { myPlayerAvatar: myPlayer.avatarComposition, avatars: (_c = myTeam === null || myTeam === void 0 ? void 0 : myTeam.players.filter((p) => p.name !== myPlayer.name).map((p) => p.avatarComposition)) !== null && _c !== void 0 ? _c : [], team: (_d = myTeam === null || myTeam === void 0 ? void 0 : myTeam.teamColor) !== null && _d !== void 0 ? _d : ETeam.NONE }))] })) })));
}
export default GameInProgressPage;
